import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { Dots } from '~/UIKit';
import { useTranslation } from 'react-i18next';
import { ITrainer } from '~/Models/DTO/Trainer.models';
import { TrainerAvatar } from '~/Hooks/useFilter/useTrainersGroupFilter';

const styles = makeStyles(() => ({
  hasMoreTrainers: {
    marginLeft: -2,
  },
}));

export const TrainerList = ({
  isTrainersLoading,
  trainerIds,
  trainersMap,
  maxNumberOfTrainerToShow = 5,
}: {
  isTrainersLoading: boolean;
  maxNumberOfTrainerToShow?: number;
  trainerIds: string[];
  trainersMap: { [key: string]: ITrainer };
}) => {
  const { classes } = styles();
  const { t } = useTranslation();

  if (!trainerIds.length) {
    return <>{t('app.noTrainer')}</>;
  }

  if (isTrainersLoading) {
    return <Dots />;
  }

  return (
    <div>
      {trainerIds.slice(0, maxNumberOfTrainerToShow).map((id) => (
        <TrainerAvatar key={id} trainer={trainersMap[id]} showTooltip />
      ))}
      {trainerIds.length > maxNumberOfTrainerToShow && (
        <span className={classes.hasMoreTrainers}>...</span>
      )}
    </div>
  );
};
